"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _validators = _interopRequireDefault(require("@jobmatchme/ui/es/utils/validators"));

var _ConfiguredInput = _interopRequireWildcard(require("../ConfiguredInput"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SingleLineText = function SingleLineText(_ref) {
  var config = _ref.config;

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue,
      track = _useContext.track;

  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      inputInvalid = _useState2[0],
      internalSetInputInvalid = _useState2[1]; // Send track data if the validation state changes


  var setInputInvalid = (0, _react.useCallback)(function (state) {
    if (state !== inputInvalid) {
      track('funnelValidationStateChange', {
        step: config.valueName,
        discriminator: context.discriminator,
        newvalidationStatusState: !state
      });
    }

    internalSetInputInvalid(state);
  }, [track, inputInvalid, config.valueName, context.discriminator, internalSetInputInvalid]);

  var handleChange = function handleChange(event) {
    var _event$target;

    var value = typeof ((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) !== 'undefined' ? event.target.value : event;
    var isValid = (0, _validators.default)(config.valueName)(value);
    setValue(config.valueName, isValid ? value : '');
    setInputInvalid(!isValid);
  };

  var handleTextboxChange = function handleTextboxChange(event) {
    setValue(config.selectBox.valueName, event.target.value);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConfiguredInput.default, {
    config: config,
    validateType: _validators.default,
    errorCode: inputInvalid ? _ConfiguredInput.CONFIGURED_INPUT_ERROR : _ConfiguredInput.CONFIGURED_INPUT_OK,
    handleChange: handleChange,
    dataProcessing: handleChange,
    handleTextboxChange: handleTextboxChange
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(SingleLineText);

exports.default = _default;